<template>
  <div class="popup_in">
    <div class="popup">
      <div class="popup_close close-animate">
        <a href="javascript:void(0);" @click.prevent="$emit('close')">
          <CloseSvg />
        </a>
      </div>

      <div v-show="!isUpload">
        <div class="title">רופא/ה יקר/ה לתשומת ליבך,</div>
        <div>
          ב-30 הימים הקרובים עתיד לפוג ביטוח האחריות המקצועית המעודכן במערכות
          בית החולים. יש ליצור קשר עם מוקד חדר ניתוח, טרם תחסם האפשרות לשיבוץ
          ניתוח במערכת.<br />
          תודה.
        </div>
        <div style="margin-top: 20px;">
          <table class="table table-striped table-policies" cellspacing="0">
            <thead>
              <th class="tx--white">שם הביטוח</th>
              <th class="tx--white">תאריך תום תוקף</th>
            </thead>
            <tbody>
              <tr
                v-for="policy in activeDoctorPolicies"
                :key="policy.policy_number"
              >
                <td>{{ policy.policy_name }}</td>
                <td>
                  {{
                    $moment(policy.end_datetime, "YYYY-MM-DD").format(
                      "DD/MM/YYYY"
                    )
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <a
          class="bt_blue bt-policies"
          @click="$emit('close')"
          href="javascript:void(0);"
        >
          הבנתי המשך
        </a>
        <a
          class="bt_blue bt-policies"
          @click="isUpload = true"
          href="javascript:void(0);"
          style="margin-right: 5px;"
        >
          טעינת קובץ ביטוח
        </a>
      </div>

      <UploadPolicies
        v-show="isUpload"
        :inPopup="true"
        @close="$emit('close')"
      />
    </div>
  </div>
</template>

<script>
import CloseSvg from "../../assets/img/svg/close.svg";
import UploadPolicies from "./UploadPolicies.vue";
import { mapGetters } from "vuex";

export default {
  name: "Policies",
  components: {
    CloseSvg,
    UploadPolicies
  },
  computed: {
    ...mapGetters(["activeDoctorPolicies"])
  },
  data() {
    return {
      isUpload: false
    };
  }
};
</script>

<style>
.popup-policies {
  overflow: scroll;
  max-height: 80vh;
}

.table-policies {
  width: 100%;
  text-align: right;
  background: #e1e1de;
  border-radius: 8px;
  overflow: hidden;
  border: none;
}

.table-policies th {
  font-weight: normal;
  font-size: 23px;
}

.table-policies th,
.table-policies td {
  padding: 6px 8px;
}

.table-policies tr td:first-child {
  font-size: 23px;
  padding-left: 6%;
}

.table-policies tr td:last-child {
  width: 26%;
}

.table-policies tr:nth-of-type(2n + 2) {
  background: white;
}

.bt-policies {
  margin-top: 20px;
}

@media only screen and (min-width: 1200px) {
  .bt-policies {
    height: 60px;
    font-size: 28px;
    line-height: 60px;
    padding: 0 18px;
  }
}
</style>
